
import http from '@/components/services/http-common';
import DataFilter from '@/components/DataFilter';
import CreateDialog from '../Create.vue';
import * as moment from "moment/moment"

export default {
    name: "Todo",
    components: {
        'data-filter': DataFilter,
        'create-dialog': CreateDialog,

    },
    props: ["breadcrumbs", "icon"],
    watch: {
        dialog(val) {
            if(!this.dialog)
                this.item=null;
        },
        tableParams: {
            handler (val) {
                this.fetchData();
            },
            deep: true,
        },
        filters: {
            handler (val) {
                this.tableParams.page=1;
                this.fetchData();
            },
            deep: true,
        },

    },
    computed: {
        params: function() {
            return {...this.tableParams, ...this.filters}
        },
        
    },
    data () {
        return {
            ROOT_URL: "EmployeeDailyTodos/employee",
            exportPrompt: false,

            //filter
            tableParams: {
                sortBy: [],
                sortDesc: [],
                page: 1,
            },
            filters:{
                code: null,
                employeeCode: null,
                employeeName: null,
                deparmentCode: null,
                shiftCode:null,
            },
            departmentSearch:null,
            departments: [],
            shifts:[],
            rowCount: 0,

            filter: {
                menu: false,
                search: "",
                searchAttr: "name",
                searchAttrs: undefined,
                FilterAttrs: [],
                FilterOn:["DepartmentTypeCode"],
                
                from: undefined,
                to: undefined,
                fromOns: [
                ],
                fromOn: "",
            },
            
            // VIEW DATA
            filterOpen: 1,

            //DATA TABLE
            totalItem: 0,
            items: [],
            search:"",
            options: {},
            isLoading: true,

            dialog: false, item: null,
            dialogDelete: false,
            targetItem: undefined,

            headers: [
                // { text: 'Thao tác', value: 'actions', width: 70},
                { text: 'Mã', align: 'start', value: 'code', width: '7rem'},
                { text: 'Nhân viên', align: 'start', value: 'employeeName', width: '100px'},
                { text: 'Phòng ban', align: 'start', value: 'departmentName', width: '100px'},
                { text: 'Ngày', align: 'start', value: 'dateStr', width: '100px'},
                { text: 'Công việc', align: 'start', value: 'todos', width: '500px'},
                { text: 'Ghi chú', align: 'start', value: 'note'},
            ],
            
        }
    },
    methods: {
        formatTime(value) {
            return moment(value).format("DD/MM/YYYY HH:mm:ss");
        },
        fetchData () {
            return http.get(this.ROOT_URL, {
                params: {
                    month: moment().startOf('month').format('YYYY-MM-DD')
                }
            })
            .then(res => {
                console.log(res.data.datas);
                this.items = res.data.datas;
                this.isLoading = false;
            });
        },
        edit(item){
            this.item = item;
            this.dialog = true;
        },
        
        remove(item){
            this.dialogDelete = true;
            this.targetItem = item;
        },
        cfmDeleteItem() {
            // http.delete(this.ROOT_URL+this.targetItem.code).then(res => {
            //     this.fetchData();
            //     this.dialogDelete = false;
            // })
        },
    },
    created () {
        this.fetchData();
    },
    
}